/**
 * Function to add/remove query value from param group (categories, tags/filters)
**/
export default function (param, val) {
  if (val) {
    param = param ? param.split(',') : []
    // remove
    if (param.includes(val)) {
      param.splice(param.indexOf(val), 1)
    // add
    } else {
      param.push(val)
    }
    param = param.join(',') // format back to string
  }
  return param // string || undefined
}
